import { Box } from '@spark-web/box';
import { CheckCircleIcon } from '@spark-web/icon';
import { Text } from '@spark-web/text';

const ConfirmFileUpload = ({ confirmationText }) => {
  return (
    <Box border="field" borderRadius="small" display="flex" padding="small" alignItems="center" gap="small">
      <CheckCircleIcon tone="primary" />
      <Box flex={1}>
        <Text>{confirmationText}</Text>
      </Box>
    </Box>
  );
};

export { ConfirmFileUpload };
